import * as actionTypes from '../actionTypes';

// initial state
export const initialState = {
  trail : []
};


export default function worksheetsReducer(state = initialState, {type, ...action}) {
  const {
    worksheet,
    path
  } = action;

  let trail = state.trail.slice(0);
  let index;

  switch (type) {
    case actionTypes.UPDATE_WORKSHEET:

      let placeholder = null;
      index = trail.findIndex(w => w.worksheet === worksheet);
      if (~index) {
        placeholder = trail[index];
        trail.splice(index, 1);
      }

      placeholder = placeholder || {worksheet};
      placeholder.path = path;
      trail.unshift(placeholder);

      return {...state, trail};

    case actionTypes.REMOVE_WORKSHEET:

      index = trail.findIndex(w => w.worksheet === worksheet);
      if (~index) {
        trail.splice(index, 1);
      }

      return {...state, trail};

    case actionTypes.LOG_OUT :
      return {...initialState};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/worksheets.js